<template>
  <Card class="series-item clickable" v-if="series">
    <div class="card-header series-item__header typography--body-2">
      {{ getGradeLabel(series) }} {{ getSubjectLabel(series) }}
    </div>

    <div class="card-block">
      <div class="card-title series-item__title typography--body-1"
           v-bind:title="series.name">
        {{ series.name }}
      </div>

      <p class="card-text">
        <small class="text-muted typography--caption typography--color-secondary">
          {{ $t('publishers.series.chapter_count', { cnt: series.chapters_count }) }}
        </small>
      </p>
    </div>

    <div class="series-item__cover-img-thumb" v-bind:style="coverImageStyle"></div>
  </Card>
</template>

<script>
  import { mapGetters } from 'vuex';
  import labels from '@/mixins/labels';

  export default {
    name: 'series-item',

    props: {
      series: {
        type: Object,
        default: null,
      },
    },

    mixins: [
      labels,
    ],

    computed: {
      ...mapGetters([
        'subjectMap',
        'gradeMap',
      ]),

      coverImageStyle() {
        if (this.series && this.series.cover_image) {
          return {
            'background-image': `url('${this.series.cover_image}')`,
          };
        }

        return {};
      },
    },
  };
</script>

<style lang="scss">
  .series-item {
    .series-item__header {
      background-color: #f7f7f7;
    }

    .series-item__title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; /* number of lines to show */
      max-height: 1.5em;    /* fallback */
    }

    .series-item__cover-img-thumb {
      height: 144px;
      background-color: #f7f7f7;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      @media (max-width: 575px) {
        height: 200px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/publishers/components/SeriesItem.vue